import { render, staticRenderFns } from "./GeneralLoading.vue?vue&type=template&id=3458452c&"
import script from "./GeneralLoading.vue?vue&type=script&lang=js&"
export * from "./GeneralLoading.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLoading.vue?vue&type=style&index=0&id=3458452c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports